import { Component, inject, Input, OnInit } from '@angular/core';
import { RoomProtocol } from '@shared/transport.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs';
import { LoaderComponent } from '@shared/component/loader/loader.component';
import { ShowProtocolComponent } from '@shared/component/_dialog/show-protocol/show-protocol.component';
import { RoomService } from '@shared/service/room.service';
import { ModalController } from '@ionic/angular/standalone';

@UntilDestroy()
@Component({
  selector: 'app-show-protocol-dialog',
  standalone: true,
  imports: [
    ShowProtocolComponent,
    LoaderComponent,
  ],
  templateUrl: './show-protocol-dialog.component.html',
  styleUrl: './show-protocol-dialog.component.scss'
})
export class ShowProtocolDialogComponent implements OnInit {
  private _modalCtrl = inject(ModalController);
  @Input() data: any;

  protocol: RoomProtocol;
  loading = false;

  private _roomService = inject(RoomService);

  ngOnInit(): void {
    if (this.data) {
      this.protocol = this.data.protocol;
      if (!this.data.load) {
        this.protocol.plan = this.protocol.plan?.replaceAll('\n', '<br/>');
        return;
      }
      this.loading = true;
      this._roomService.getProtocol(this.protocol.id)
        .pipe(untilDestroyed(this), finalize(() => this.loading = false))
        .subscribe(res => {
          this.protocol = res;
          this.protocol.plan = this.protocol.plan?.replaceAll('\n', '<br/>');
        });
    }
  }

  closeModal(data?: any): void {
    this._modalCtrl.dismiss(data);
  }

}
